/**
 * Header controls.
 */
export default function headerSection() {

  // Navigation buttons and clicks
  const navi = document.getElementById('mobileMenu');
  const naviButton = document.getElementById('mobileMenuButton');

  if (navi) {
    const menuToggle = event => {

      navi.classList.toggle('open');
      navi.classList.toggle('closed');

      document.documentElement.classList.toggle('locked');

      event.stopImmediatePropagation();
      event.preventDefault();
    };

    naviButton.addEventListener('click', menuToggle);
    navi.addEventListener('click', event => {
      event.stopImmediatePropagation();
    });

    // Sub menu expansion
    document.querySelectorAll('#mobileMenu ul.top li.has-decendents > a').forEach(link => {
      link.addEventListener('click', event => {
        if (link.parentNode.classList.contains('minimised')) {
          link.parentNode.classList.replace('minimised', 'expanded');
        } else {
          link.parentNode.classList.replace('expanded', 'minimised');
        }
        event.preventDefault();
      });
    });

    // fade body on mega menu
    const fader = document.getElementById('fader');
    const parentLinks = document.querySelectorAll('.header__main__menu li.has-decendents');
    parentLinks.forEach(link => {
      link.addEventListener('mouseenter', event => {
        fader.classList.replace('closed', 'open');
      });
      link.addEventListener('mouseleave', event => {
        fader.classList.replace('open', 'closed');
      });
    })
  }

}



// WEBPACK FOOTER //
// ./source/scripts/sections/header.js